import {
  StyledBottomPartSubTitle,
  StyledCardImg,
  StyledContentWrapper,
  StyledCustomerNumberSubTitle,
  StyledSeasonSubTitle,
  StyledSubCardContainer,
  StyledSubCardTBottomPartContainer,
  StyledSubCardTopPart,
  StyledSubName,
  StyledWrapper,
} from './styles'
import hapoelImg from 'assets/images/subscriptionHapoel.png'
import { useTranslation } from 'react-i18next'
import { SeasonTicket } from 'store/api-slices/userSlice'
import { PersonalAreaSwiper } from '../../personalAreaSwiper/PersonalAreaSwiper'

type SubscriptionsProps = {
  subscriptions: SeasonTicket[]
}

export const SubscriptionsSwiper = ({ subscriptions }: SubscriptionsProps) => {
  const { t } = useTranslation('', {
    keyPrefix: 'pages.personalArea.tabs.subscriptions',
  })

  const areaSeatTranslationResolver = (area: string | undefined) => {
    switch (area) {
      case 'Court':
        return t('subscriptionContent.court')
      case 'Suite':
        return t('subscriptionContent.suite')
      case 'Gallery':
        return t('subscriptionContent.gallery')
      case 'Court_side':
        return t('subscriptionContent.courtSide')
      default:
        return t('subscriptionContent.unmarked')
    }
  }

  const areaSeatRenderer = (area: string | undefined) => {
    const match = area?.match(/^(.*)_(\d+)$/) || []
    const areaName = match[1] || ''
    const areaNumber = match[2] || ''
    return (
      <>
        <StyledBottomPartSubTitle>
          {areaSeatTranslationResolver(areaName)}
        </StyledBottomPartSubTitle>
        <StyledBottomPartSubTitle>{areaNumber}</StyledBottomPartSubTitle>
      </>
    )
  }

  const subscriptionsSwiperSlides = subscriptions.map((sub) => (
    <StyledSubCardContainer key={sub.ownerAccountHjbcId}>
      <StyledSubCardTopPart>
        <StyledSeasonSubTitle>
          {sub.name} <StyledSubName>{sub.ownerAccount}</StyledSubName>
        </StyledSeasonSubTitle>
      </StyledSubCardTopPart>
      <StyledSubCardTBottomPartContainer>
        <StyledWrapper>
          <div>
            <StyledCustomerNumberSubTitle>
              {t('subscriptionContent.customerNumber')}
            </StyledCustomerNumberSubTitle>
            <StyledBottomPartSubTitle>
              {sub.ownerAccountHjbcId}
            </StyledBottomPartSubTitle>
          </div>
          <div>
            <StyledCardImg src={hapoelImg} alt="" />
          </div>
        </StyledWrapper>
        <StyledWrapper>
          <StyledContentWrapper>
            {areaSeatRenderer(sub.seatArea)}
          </StyledContentWrapper>
          <StyledContentWrapper>
            <StyledBottomPartSubTitle>
              {t('subscriptionContent.row')}
            </StyledBottomPartSubTitle>
            <StyledBottomPartSubTitle>{sub.seatRow}</StyledBottomPartSubTitle>
          </StyledContentWrapper>
          <StyledContentWrapper>
            <StyledBottomPartSubTitle>
              {t('subscriptionContent.seat')}
            </StyledBottomPartSubTitle>
            <StyledBottomPartSubTitle>
              {sub.seatNumber}
            </StyledBottomPartSubTitle>
          </StyledContentWrapper>
        </StyledWrapper>
      </StyledSubCardTBottomPartContainer>
    </StyledSubCardContainer>
  ))

  const slideStyle = { maxWidth: '180px' }

  return (
    <PersonalAreaSwiper
      slides={subscriptionsSwiperSlides}
      slidesKey="subscriptions"
      slidesStyle={slideStyle}
    />
  )
}
